import Header from "@/components/header";
import Footer from "@/components/footer";

import { promises as fs } from "fs";
import path from "path";
import { remark } from "remark";
import html from "remark-html";
import gfm from "remark-gfm";
import Head from "next/head";
import MapBackground from "@/components/map-background";

export default function EULA({ content }) {
  return (
    <>
      <Head>
        <title>Partbot - EULA</title>
      </Head>
      <Header />
      <main>
        <div className="relative py-24 md:py-40">
          <div className="container mx-auto">
            <div
              className="prose prose-invert mx-auto max-w-prose px-6 text-sm text-emerald-300/60 md:px-6 md:text-base"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const content = await fs.readFile(
    path.join(process.cwd(), "EULA.md"),
    "utf8",
  );

  const processedContent = await remark().use(html).use(gfm).process(content);

  return {
    props: {
      content: processedContent.toString(),
    },
  };
}
